var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLittleArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65332 5.11621C0.65332 5.35352 0.834961 5.52051 1.125 5.52051L4.88086 5.52344C5.16797 5.52344 5.34961 5.35645 5.34961 5.11914C5.34961 4.99609 5.29688 4.89355 5.22949 4.75293L3.44531 1.06152C3.31641 0.800781 3.18457 0.701172 3.00293 0.701172C2.82129 0.701172 2.68652 0.800781 2.55762 1.06152L0.773438 4.75293C0.706055 4.89062 0.65332 4.99316 0.65332 5.11621Z",
    fill: "#BFBBCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLittleArrowUp);
export default __webpack_public_path__ + "static/media/icon-little-arrow-up.73363ff86e327aeae2bb5cab30971489.svg";
export { ForwardRef as ReactComponent };